
import { mapMutations } from 'vuex'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'BurnTBSA',
components: {
XTable
},
data() {
return {
form: {
gender: '',
upper: '0',
face: '0',
neck: '0',
hand: '',
forearm: '',
arm: '',
sternoventral: '0',
dorsalis: '0',
perineum: '0',
buttock: '0',
foot: '',
calf: '',
thigh: '',
},
hasScore: false,
disabled: false,
dataList: [
{value: '1', name: '男'},
{value: '2', name: '女'}
],
dataList1: [
{value: '2.5', name: '单侧'},
{value: '5', name: '双侧'},
],
dataList2: [
{value: '3', name: '单侧'},
{value: '6', name: '双侧'},
],
dataList3: [
{value: '3.5', name: '单侧'},
{value: '7', name: '双侧'},
],
dataList4: [
{value: '3.5', name: '单侧'},
{value: '7', name: '双侧'},
],
dataList5: [
{value: '3', name: '单侧'},
{value: '6', name: '双侧'},
],
dataList6: [
{value: '6.5', name: '单侧'},
{value: '13', name: '双侧'},
],
dataList7: [
{value: '10.5', name: '单侧'},
{value: '21', name: '双侧'},
],
}
},
created() {
this.hideLoad()
},
methods: {
...mapMutations(['hideLoad']),
},
computed: {
/** 计算公式结果 */
score() {
let self = this;
let form = JSON.parse(JSON.stringify(self.form));
let flag = true;
for (const key in form) {
if (form.hasOwnProperty(key)) {
if (!form[key]) {
flag = false
} else {
if (form[key] == '---') {
flag = false
} else {
form[key] = Number(form[key])
}
}
}
}
if (!flag) {
self.hasScore = false;
return "...";
} else {
let result = form.upper * 3 + form.face * 3 + form.neck * 3 + form.hand + form.forearm
+ form.arm + form.sternoventral * 13 + form.dorsalis * 13 + form.perineum + (form.gender == 1 ? form.buttock * 5 : form.buttock * 6)
+ form.foot + form.calf + form.thigh
self.hasScore = true
return String(result.toFixed(1))
}
},
},
watch: {
'form.gender': {
handler: function (newVal, oldVal) {
if (newVal !== oldVal) {
this.form.foot = ''
}
},
immediate: true
}
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Trauma/Chart_BurnTBSA.vue